import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_015bb7a9/src/layouts/default.vue").then(m => m.default || m))
}